import {qspost} from '@/plugins/axios'

/*
 * 登录
 * @constructor jack
 * */
export const login = (username, password) => qspost('/admin/login/login', {username, password})


/*
 * 验证码接口
 * @constructor jack
 * */
export const sendPhoneCode = (phone, type) => qspost('/index/login/sendPhoneCode', {phone, type})


/*
 * 专家登录
 * @constructor jack
 * */
export const expertLogin = (phone, code) => qspost('/index/login/login', {phone, code})
